'use strict';

const React = require('react');
const ReactDOM = require('react-dom');

const { Provider } = require('react-redux');
const { match, Router } = require('react-router');
const { browserHistory } = require('react-router');

const { factory: storeFactory } = require('../common/redux-store');
const routes = require('../common/routes');

const initialState = window.document.body.dataset && window.document.body.dataset.initialstate ?
    JSON.parse(window.document.body.dataset.initialstate) : {};

const { pathname, search, hash } = window.location;
const location = `${pathname}${search}${hash}`;

// Calling `match` is to force fetching the "lazy" component for the current route
// before trying to render. React's `render` methods are sync so if we do the initial
// render without any components loaded, it simply renders an empty page, ignoring the
// server-side pre-render and then break the rest of the page.
// See https://github.com/ReactTraining/react-router/issues/2036 for a long discussion.
match({ routes, location }, () => {
    ReactDOM.render(
        <Provider store={storeFactory(initialState)}>
            <Router history={browserHistory} routes={routes} />
        </Provider>,
        window.document
    );
});



/** WEBPACK FOOTER **
 ** ./client/client.js
 **/